import request from '@/router/axios';

export const getList = (current, size, params) => {
    return request({
        url: '/api/blade-loanSecurityDeptFollow/loanSecurityDeptFollow/page',
        method: 'post',
        data: {
            ...params,
            current,
            size
        }
    })
}

export const remove = (id) => {
    return request({
        url: '/api/blade-loanSecurityDeptFollow/loanSecurityDeptFollow/remove',
        method: 'post',
        data: {
            id,
        }
    })
}

export const add = (row) => {
    return request({
        url: '/api/blade-loanSecurityDeptFollow/loanSecurityDeptFollow/saveOrUpdate',
        method: 'post',
        data: row
    })
}

export const update = (row) => {
    return request({
        url: '/api/blade-loanSecurityDeptFollow/loanSecurityDeptFollow/saveOrUpdate',
        method: 'post',
        data: row
    })
}

export const updateBondFollow = (row) => {
    return request({
        url: '/api/blade-loanSecurityDeptFollow/loanSecurityDeptFollow/updateSecurity',
        method: 'post',
        data: row
    })
}


export const exportData = (data) => {
    return request({
        url: `/api/blade-loanSecurityDeptFollow/loanSecurityDeptFollow/export-loanSecurityDeptFollow`,
        method: "post",
        responseType: 'blob',
        data: data,
    });
}